import React, { useState, useEffect } from 'react';
import Header from '../components/Layout/Header';
import LeftSidebar from '../components/Layout/LeftSidebar';
import RightSidebar from '../components/Layout/RightSidebar';
import HeroBanner from '../components/Layout/HeroBanner';
import PostFeed from '../components/PostFeed/PostFeed';
// import { useAuth } from '../context/AuthContext';
import './Dashboard.css';
import MobileSidebar from '../components/Layout/mobileSidebar';

const MOBILE_TABLET_BREAKPOINT = 1024; // px
const SIDEBAR_STICKY_TOP_MAX = 72; // px, keeps sidebars below sticky header

const Dashboard: React.FC = () => {
  // const { user } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(
    () =>
      typeof window !== 'undefined'
        ? window.innerWidth <= MOBILE_TABLET_BREAKPOINT
        : true
  );
  const [sidebarStickyTop, setSidebarStickyTop] = useState(0);

  useEffect(() => {
    const onResize = () =>
      setIsMobileOrTablet(window.innerWidth <= MOBILE_TABLET_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (isMobileOrTablet) {
      setSidebarStickyTop(0);
      return;
    }

    const leftSidebar = document.querySelector<HTMLElement>('.left-sidebar');
    const rightSidebar = document.querySelector<HTMLElement>('.right-sidebar');
    if (!leftSidebar || !rightSidebar) {
      setSidebarStickyTop(0);
      return;
    }

    const updateStickyOffset = () => {
      const viewportHeight = window.innerHeight;
      const leftSidebarHeight = leftSidebar.getBoundingClientRect().height;
      const rightSidebarHeight = rightSidebar.getBoundingClientRect().height;
      const tallestSidebarHeight = Math.max(leftSidebarHeight, rightSidebarHeight);
      const computedTop = viewportHeight - tallestSidebarHeight;
      setSidebarStickyTop(Math.min(SIDEBAR_STICKY_TOP_MAX, computedTop));
    };

    updateStickyOffset();

    const observer = new ResizeObserver(updateStickyOffset);
    observer.observe(leftSidebar);
    observer.observe(rightSidebar);
    window.addEventListener('resize', updateStickyOffset);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateStickyOffset);
    };
  }, [isMobileOrTablet]);

  return (
    <div className="dashboard">
      <Header />
      {/* Hamburger for mobile/tablet only */}
      {isMobileOrTablet && (
        <button
          className="hamburger-btn"
          aria-label="Open menu"
          onClick={() => setMobileSidebarOpen(true)}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>
      )}
      <br />
      <div
        className="dashboard-content"
        style={{ '--sidebar-sticky-top': `${sidebarStickyTop}px` } as React.CSSProperties}
      >
        {/* show left/right sidebars on desktop */}
        {!isMobileOrTablet && <LeftSidebar />}
        <main className="main-content">
          <HeroBanner />
          <PostFeed />
        </main>
        {!isMobileOrTablet && <RightSidebar />}
      </div>
      {isMobileOrTablet && mobileSidebarOpen && (
        <MobileSidebar onClose={() => setMobileSidebarOpen(false)} />
      )}
      <br />
    </div>
  );
};

export default Dashboard;
